import {Component, OnInit, Output, EventEmitter, ElementRef, ViewChild} from '@angular/core';
import {ImgPerspectiveComponent} from "../components/img-perspective/img-perspective.component";

declare var TiltFx, TimelineMax, jQuery, TweenMax, Power2, Sine;


@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.less']
})
export class AboutComponent implements OnInit {
    @Output() animOpenSectionEnded: EventEmitter<any> = new EventEmitter();
    @Output() animCloseSectionEnded: EventEmitter<any> = new EventEmitter();

    @ViewChild(ImgPerspectiveComponent) public imgPerspectiveComponent: ImgPerspectiveComponent;

    isComponentLoading: boolean = true;
    isTiltImgActivated: boolean = false;

    tl_about: any;
    animatedElems: any = {};

    constructor(private elRef: ElementRef) {
    }

    ngOnInit() {
        let _this = this;

        this.tl_about = new TimelineMax({
            paused: true,
            repeat: 0,
            force3d: true,
            onComplete(){
                _this.animOpenSectionEnded.emit();
                _this.isComponentLoading = false;
            },
            onReverseComplete(){
                // _this.animCloseSectionEnded.emit();
                _this.isTiltImgActivated = false;
            }
        });

        this.isTiltImgActivated = true;
        // TweenMax.set(this.imgPerspectiveComponent.animatedElems.imgElem, {autoAlpha:0});
    }

    ngOnDestroy() {
        this.tl_about.kill();
        this.tl_about = null;
    }

    ngAfterViewInit() {
        this.setupElems();
        this.tl_setupAnimIntro();

        setTimeout(()=> {
            this.tl_about.play();
        }, 10);
    }

    setupElems() {
        this.animatedElems.title = jQuery('[line-web-developer]', this.elRef.nativeElement);
        this.animatedElems.aboutTxt = jQuery('[line-web-developer]', this.elRef.nativeElement);
    }

    componentAnimOut() {
        this.tl_about.reverse();
        TweenMax.fromTo(this.imgPerspectiveComponent.animatedElems.imgElem, 1, {autoAlpha: 1}, {
            autoAlpha: 0,
            delay: .8
        });

        setTimeout(()=> {
            this.animCloseSectionEnded.emit();
        }, 1600);
    }

    tl_setupAnimIntro() {
        this.tl_about.add("anim_fadeToLeft", 0.05);
        let arrayAnims = this.tweens_getAnimFadeToLeft();

        let t_1 = TweenMax.fromTo(this.imgPerspectiveComponent.animatedElems.imgElem, 1.2, {x: "10%"}, {x: "0%"});

        arrayAnims.push(t_1);
        this.tl_about.add(arrayAnims, "anim_fadeToLeft");
    }

    tweens_getAnimFadeToLeft() {
        let arrayTweens = [];

        jQuery('[anim--fade-in-to-left]', this.elRef.nativeElement).each(function (index, elem) {
            let tween = TweenMax.fromTo(jQuery(elem), 1.3, {x: "20%", autoAlpha: 0}, {
                x: "0%",
                autoAlpha: 1,
                delay: (index * .3),
                ease: Sine.easeOut
            });
            arrayTweens.push(tween);
        });

        return arrayTweens;
    }
}



// WEBPACK FOOTER //
// /Users/davidlagace/Sites/david-lagace-website/src/app/about/about.component.ts